import * as Yup from "yup";

export default Yup.object().shape({
  status: Yup.string()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .required("Status is required"),
  startDate: Yup.date().required("Start date is required"),
  endDate: Yup.date()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .when("status", {
      is: (val) => val === "Probation" || val === "Notice_Period",
      then: (schema) => schema.required("End date is required"),
      otherwise: (schema) => schema.nullable(true),
    }),
});
